<template>
  <transition name="food-detail">
    <div class="food" v-show="showFlag" ref="foodView">
      <div class="food-wrapper">

        <div class="food-content">
          <div class="img-wrapper">
            <img class="food-img" :src="food.picture" />

            <span class="close-bt icon-close" @click="closeView"></span>
            <img class="share-bt" src="./share.png" />
            <img class="more-bt" src="./more.png" />
          </div>

          <div class="content-wrapper">
            <h3 class="name">{{food.name}}</h3>
            <p class="saled">{{food.month_saled_content}}</p>
            <img class="product" v-show="food.product_label_picture" :src="food.product_label_picture" />

            <p class="price">
              <span class="text">$ {{food.min_price}} </span>
              <span class="unit"> / {{food.unit}}</span>
            </p>
            <div class="food-cartcontrol-wrapper">
              <Cartcontrol :food="food"></Cartcontrol>
            </div>
            <div class="buy" v-show="!food.count || food.count==0" @click="addFirst">
              選規格
            </div>

          </div>
        </div>

        <!-- 上下分隔線 -->
        <Split></Split>

        <!-- 評價 -->
        <div class="rating-wrapper">
          <div class="rating-title">
            <div class="like-ratio" v-if="food.rating">
              <span class="title">{{food.rating.title}}</span>
              <span class="ratio">
                (
                  {{ food.rating.like_ratio_desc }}
                  <i>{{ food.rating.like_ratio }}</i>
                )
              </span>
            </div>
            <div class="snd-title"  v-if="food.rating">
              <span class="text">{{food.rating.snd_title}}</span>
              <span class="icon icon-keyboard_arrow_right"></span>
            </div>
          </div>

          <ul class="rating-content" v-if="food.rating">
            <li v-for="comment in food.rating.comment_list" class="comment-item">
            <!-- <li v-for="comment in food.rating.comment_list" class="rating-item"> -->
              <div class="comment-header">
                <img :src="comment.user_icon" v-if="comment.user_icon"/>
                <img src="./anonymity.png" v-if="!comment.user_icon" />
              </div>
              <!-- <div class="comment-main">
                <div class="user">
                  {{ comment.user_name }}
                </div>
                <div class="time">
                  {{ comment.user_time }}
                </div>
                <div class="content">
                  {{ comment.user_content }}
                </div>
              </div> -->
              <div class="comment-main">
								<div class="user">
									{{comment.user_name}}
								</div>
								<div class="time">
									{{comment.comment_time}}
								</div>
								<div class="content">
									{{comment.comment_content}}
								</div>
							</div>
            </li>
          </ul>
        </div>
      </div>

    </div>
  </transition>
</template>
<script>
// 引入BetterScroll
import BScroll from '@better-scroll/core'
import Cartcontrol from '../Cartcontrol/Cartcontrol'
import Vue from 'vue'
import Split from '../Split/Split'
export default {
    data(){
        return {
            showFlag:false
            }
        },
        props:{
          food:{
            type:Object
          }
        },
        methods:{
          // 副組件可以調用子組件的方法
          showView(){
            this.showFlag = true
              // console.log(this.food)
              // console.log(this.food.min_price)
              // console.log(this.food.rating.title)


              //在這裡進行BScroll初始化
              this.$nextTick(()=>{
                if(!this.scroll){
                  this.scroll = new BScroll(this.$refs.foodView,{
                    click:true
                  })
                }  else {
                  this.scroll.refresh()
                }
              })
          },
          closeView(){
            this.showFlag = false
          },
          addFirst(){
            Vue.set(this.food,"count",1)
          },
        },
        components:{
          Cartcontrol,
          BScroll,
          Split
        }
  }
</script>
<style>
  @import url("Food.css");
</style>



// WEBPACK FOOTER //
// src/components/Food/Food.vue